module.exports = __webpack_public_path__ + "img/congratulations.a47592ec.png";